<template>
  <div class="WelcomePage order-place-welcome">
    <Header classes="order-place-header" />
    <div class="multi-button order-place-shell">
      <div class="order-place-inner">
        <div class="order-place-main-grid">
          <div class="order-place-calendar-pane">
            <div class="order-place-calendar-wrap">
              <HomeBookingCalendar class="order-place-calendar">
                <KotDayReports slot="reports" />
              </HomeBookingCalendar>
            </div>
          </div>
        </div>

        <Bill
          :Order="OrderDetails"
          :paymentAmount="paymentAmount"
          v-show="completeBill"
          ref="Bill"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {Header} from '@/components/index.js';
import Bill from '../components/Share/Bill/index';
import HomeBookingCalendar from '../components/Share/HomeBookingCalendar/index.vue';
import KotDayReports from '../components/Share/KotDayReports/index.vue';
import {mapState} from 'vuex';
import axios from '@/plugins/axios';

export default {
  data() {
    return {
      OrderDetails: [],
      PaymentAmount: null,
      paymentType: null,
    };
  },
  computed: {
    ...mapState('orders', ['OrderTableDetails']),
    ...mapState('orders', ['OrderTableDetailsVisible']),
    decodedUser() {
      return this.$store.getters['auth/GetDecodedUser'];
    },
    userType() {
      return this.decodedUser ? this.decodedUser.usertype : null;
    },
  },

  components: {
    Header,
    Bill,
    HomeBookingCalendar,
    KotDayReports,
  },
  created() {
    const token = localStorage.getItem('jhms_token');
    if (token) {
      this.$store.dispatch('sitesetting/GetSettings').catch(() => {});
    }
  },
  methods: {
    GetLastBill() {
      let promise = this.GetOrder();
      promise.then(res => {});
    },
    // goToKOT() {
    //   this.$router.push({ name: "KitchenOrders" });
    // },
    GetOrder() {
      return new Promise((resolve, reject) => {
        axios
          .get(`hms/web/orders/${this.OrderTableDetails}`)
          .then(res => {
            // this.paymentType = res.data;
            this.PaymentAmount = res.data.paid_amount;
            this.OrderDetails = res.data;

            setTimeout(() => this.$refs.Bill.print(), 400);

            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
  },
};
</script>
<style scoped>
.order-place-welcome {
  height: calc(100dvh - var(--app-footer-height, 28px));
  max-height: calc(100dvh - var(--app-footer-height, 28px));
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  background: #f8fafc;
}

.order-place-welcome >>> .order-place-header.header_in,
.order-place-welcome >>> header.header_in {
  flex-shrink: 0;
  position: relative !important;
  top: auto !important;
  border-bottom: none;
  box-shadow: none;
}

.order-place-welcome >>> .home-booking-calendar {
  border-top: none;
}

.order-place-shell {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  padding: 0;
  box-sizing: border-box;
  margin-top: 0;
  overflow: hidden;
  background: #f8fafc;
}

.order-place-inner {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  overflow: hidden;
}

/* Calendar fills the area; quick portal icons are in the calendar toolbar. */
.order-place-main-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.order-place-calendar-pane {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
}

.order-place-calendar-wrap {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.order-place-calendar {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
}


.order-place-calendar-pane >>> .home-booking-calendar {
  max-width: none;
  width: 100%;
  height: 100%;
  min-height: 0;
  margin: 0;
}

.center-takeaway {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 25%;
  -ms-transform: translate(-25%, -25%);
  transform: translate(-25%, -25%);
}

.center-room {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.center-table {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 75%;
  -ms-transform: translate(-75%, -75%);
  transform: translate(-75%, -75%);
}

body {
  background-color: #e0e5ec;
  height: 100vh;
  margin: 0;
  display: grid;
  place-items: center;
}

.effect:after {
  content: '';
  position: absolute;
  top: 0;
  left: 30px;
  width: 80%;
  height: 80%;
  opacity: 0;
  transform: translateX(-50%);

  background: rgba(255, 255, 255, 0.13);
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.13) 0%,
    rgba(255, 255, 255, 0.13) 77%,
    rgba(255, 255, 255, 0.5) 92%,
    rgba(255, 255, 255, 0.3) 100%
  );
}

.effect:hover:after {
  opacity: 1;
  top: 0;
  left: 30px;
  transform: translateX(0);
  transition: transform 0.7s ease, opacity 0.15s ease;
}

.effect:active:after {
  opacity: 0;
}

.icon_2_style {
  padding: 20px;
  font-size: 50px;
}

/* .KOTButton2 {
  border-radius: 5%;
  height: 30px;
  width: 120px;
  font-size: 12px;
  margin-left: -5px !important;
  margin-top: 5px !important;
  background: #ff6d00;
  border: none;
  outline: none;
  color: #ffffff !important;
} */
</style>
